import BimatterViewer from "bimatter-viewer";

export function keyEv(e: KeyboardEvent, viewer: BimatterViewer) {
    //@ts-ignore
    if (viewer.settings.keysDisable) {
        return;
    }
    if (e.code === "Escape") {
        if (viewer.utils.dimentionsUtils.active) {
            viewer.utils.dimentionsUtils.cancelDrawing();
        } else {
            viewer.selector.selection.resetSelect(true);
        }
        // ViewerSelect.ViewerRemoveSelect(viewer, models, dispatch);
    }
    if (e.code === "Digit1") {
        if (viewer.context.controls.activeMode !== "1stPerson") {
            viewer.context.controls.settings.speed = 0.03;
            viewer.context.controls.settings.upSpeed = 0.0005;
            viewer.context.controls.settings.rotateSpeed = 0.0005;

            viewer.context.controls.activeMode = "1stPerson";
            const gui = viewer.utils.gui;
            gui.show();
            gui.controllers.map((c) => c.destroy());
            gui.title("1st person settings");
            gui.add(viewer.context.controls.settings, "speed", 0, 0.5).name(
                "Moving speed"
            );
            gui.add(
                viewer.context.controls.settings,
                "rotateSpeed",
                0,
                0.1
            ).name("Rotate speed X");
            gui.add(viewer.context.controls.settings, "upSpeed", 0, 0.1).name(
                "Rotate speed Y"
            );
        } else {
            const gui = viewer.utils.gui;
            gui.controllers.map((c) => c.destroy());
            gui.hide();
            viewer.context.controls.activeMode = "Orthographic";
        }
    }
    if (e.code === "Tab") {
        e.stopPropagation();
        e.preventDefault();
        if (viewer.utils.dimentionsUtils.measureStart) {
            viewer.utils.dimentionsUtils.changeAxes();
        }
    }
    if (e.code === "KeyM") {
        viewer.utils.dimentionsUtils.toggleDimentionsActive();
    }
    if (e.code === "KeyC") {
        if (viewer.utils.dimentionsUtils.active) {
            viewer.utils.dimentionsUtils.deleteAll();
        } else {
            viewer.utils.geometryUtils.showAll();
            visibilityTrigger(viewer);
            // if (e.altKey) {
            //     viewer.utils.geometryUtils.resetAllModelsChunks();
            // } else {

            // }
        }
    }

    if (e.code === "KeyH") {
        viewer.utils.geometryUtils.hideSelectedElements();
        visibilityTrigger(viewer);
    }
    if (e.code === "KeyI") {
        viewer.utils.geometryUtils.isolateSelectedElements();
        visibilityTrigger(viewer);
    }
    if (e.code === "KeyO") {
        viewer.context.controls.setOrbitByClick();
    }
    if (e.code === "KeyP") {
        if (e.altKey) {
            viewer.utils.clippingUtils.deleteAllPlanes();
        } else {
            const plane = viewer.utils.clippingUtils.createPlane();
        }
    }
}

export function visibilityTrigger(viewer: BimatterViewer) {
    if (!viewer) return;
    viewer.container.dispatchEvent(new CustomEvent("hideTrigger"));
}
